import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfiguration } from '../../../context/configurationContext';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink, ListingTypeModal } from '../../../components';

import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const {
    listingsAreLoaded,
    totalItems,
    location,
    resetAll,
    showCreateListingsLink,
    onManageDisableScrolling,
  } = props;
  const [isListingTypeModalOpen, setIsListingTypeModalOpen] = useState(false);
  const config = useConfiguration();
  const history = useHistory();
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;

  const createListingLinkMaybe = showCreateListingsLink ? (
    <span
      className={css.createListingLink}
      onClick={() => setIsListingTypeModalOpen(true)}
      role="button"
      tabIndex={0}
    >
      <FormattedMessage id="SearchPage.createListing" />
    </span>
  ) : null;

  return hasNoResult ? (
    <div className={css.noSearchResults}>
      <FormattedMessage id="SearchPage.noResults" />
      <br />
      {hasSearchParams ? (
        <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
          <FormattedMessage id={'SearchPage.resetAllFilters'} />
        </button>
      ) : null}
      <p>{createListingLinkMaybe}</p>
      <ListingTypeModal
        isOpen={isListingTypeModalOpen}
        onClose={() => setIsListingTypeModalOpen(false)}
        onManageDisableScrolling={onManageDisableScrolling}
        listingTypes={config.listing.listingTypes}
        onContinue={selectedType => {
          history.push(`/l/new?listingType=${selectedType}`);
        }}
      />
    </div>
  ) : null;
};

export default NoSearchResultsMaybe;
